import { FC } from 'react';

import { Skeleton } from 'ui/skeleton';

import { EngagementSkeletonRightText, EngagementSkeletonRow } from './EngagementCard.styles';
import { Card, ColumnTextBlock, UnspacedBody2Bold } from '../Styles';

export const EngagementSkeleton: FC = () => (
  <Card data-test="brand-affinity-xai-engagement-skeleton">
    <EngagementSkeletonRow>
      <ColumnTextBlock>
        <UnspacedBody2Bold>Total Sends</UnspacedBody2Bold>
        <Skeleton height={16} width={195} />
      </ColumnTextBlock>
      <EngagementSkeletonRightText>
        <Skeleton height={40} width={34} shimmerSpeed={1000} />
      </EngagementSkeletonRightText>
    </EngagementSkeletonRow>
    <EngagementSkeletonRow>
      <ColumnTextBlock>
        <UnspacedBody2Bold>Total Opens</UnspacedBody2Bold>
        <Skeleton height={16} width={195} />
      </ColumnTextBlock>
      <EngagementSkeletonRightText>
        <Skeleton height={40} width={34} shimmerSpeed={1000} />
      </EngagementSkeletonRightText>
    </EngagementSkeletonRow>
    <EngagementSkeletonRow>
      <ColumnTextBlock>
        <UnspacedBody2Bold>Total Clicks</UnspacedBody2Bold>
        <Skeleton height={16} width={195} />
      </ColumnTextBlock>
      <EngagementSkeletonRightText>
        <Skeleton height={40} width={34} shimmerSpeed={1000} />
      </EngagementSkeletonRightText>
    </EngagementSkeletonRow>
  </Card>
);
